import React, { useState } from "react"
import Title from "./title"
import { useStaticQuery, graphql } from "gatsby"

// Styles
import styles from "../styles/components/transformations.module.scss"

const Transformations = () => {
  const [showAll, setShowAll] = useState(false)
  const data = useStaticQuery(graphql`
    query {
      image1: file(relativePath: { eq: "transformations/0.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1650, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image2: file(relativePath: { eq: "transformations/1.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image3: file(relativePath: { eq: "transformations/2.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image4: file(relativePath: { eq: "transformations/3.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image5: file(relativePath: { eq: "transformations/4.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image6: file(relativePath: { eq: "transformations/5.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image7: file(relativePath: { eq: "transformations/6.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image8: file(relativePath: { eq: "transformations/7.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image9: file(relativePath: { eq: "transformations/8.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image10: file(relativePath: { eq: "transformations/9.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  // Pixel bounds of the original photographs inside each legacy collage.
  // Display-only crops preserve the original bodies and source files.
  const crops = [
    [[50,43,528,710],[667,52,565,714],1280,1008],
    [[97,64,370,540],[552,61,275,540],1125,851],
    [[86,28,270,410],[644,28,247,410],1125,724],
    [[1,185,520,880],[525,183,518,880],1047,1280],
    [[74,69,565,960],[645,69,574,960],1280,1138],
    [[62,51,529,810],[600,55,615,590],1280,1035],
    [[166,180,330,510],[603,224,608,650],1280,1097],
    [[43,48,514,598],[609,42,607,469],1280,853],
    [[80,191,495,695],[581,191,507,570],1146,1080],
    [[13,18,525,715],[556,18,552,855],1125,1063],
  ]
  const photos = Object.keys(data).map(key => data[key].childImageSharp.fluid)
  return (
    <section className={styles.main} id="transformations">
      <Title text="Body Transformations" />
      <p className={styles.intro}>Our members. Their progress.</p>
      <div className={styles.grid} id="transformation-gallery">
        {photos.slice(0, showAll ? photos.length : 3).map((photo, index) => (
          <article className={styles.card} key={photo.src} aria-label={`Before and after comparison ${index + 1}`}>
            <div className={styles.comparison}>
              {crops[index].slice(0,2).map(([x,y,w,h], side) => (
                <div className={styles.panel} key={side}>
                  <span className={styles.label}>{side === 0 ? "Before" : "After"}</span>
                  <div className={styles.photo}>
                    <div className={styles.crop} style={{ "--ratio": w/h }}>
                      <img src={photo.src} srcSet={photo.srcSet} sizes="600px" loading="lazy" alt={`${side === 0 ? "Before" : "After"} training, original member photograph`} style={{ width: `${crops[index][2]/w*100}%`, height: `${crops[index][3]/h*100}%`, left: `${-x/w*100}%`, top: `${-y/h*100}%` }} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
      <button className={styles.more} aria-expanded={showAll} aria-controls="transformation-gallery" onClick={() => setShowAll(!showAll)}>{showAll ? "Show fewer transformations" : "View all transformations"}</button>
    </section>
  )
}
export default Transformations
